<script setup lang="ts">

import { Backgrounds, usePresentation } from '@presentation/Types';

const presentation = usePresentation();
presentation.backgroundImage = Backgrounds.Five;

</script> 

<template>

    <Page>

        <h2 class="mb-4 text-2xl 2xl:text-4xl font-semibold">DMS Integration</h2>

        <p class="text-xl 2xl:text-3xl text-justify font-normal text-white/80 max-w-[80%]">
            Carbucks obtains Dealership Management System (DMS) data through a variety of methods, 
            depending on each dealership's setup. 
        </p>

        <p class="text-xl 2xl:text-3xl text-justify font-normal text-white/80 mt-3 max-w-[80%]">
            In some cases, we integrate via API to securely and automatically access the required information. 
            Where APIs are not available, we extract data from PDF reports generated by the DMS. 
        </p>

        <p class="text-xl 2xl:text-3xl text-justify font-normal text-white/80 mt-3 max-w-[80%]">
            In every instance, we work closely with each dealership site to ensure accurate and complete 
            data capture, supporting both compliance and operational success.        
        </p>

    </Page>

</template>